import React, { useEffect, useRef } from 'react'
import { useDispatch } from 'react-redux'
import { useHistory, useLocation } from 'react-router-dom'
import { history, useTypedSelector } from '../redux/store'
import { delTabsAction } from '../modules/authtoken'
import { delModuleDataAction, setModuleDataAction } from '../modules/pagecache'

/**
 * 获取url参数用的hook
 * @returns
 */
export function useQuery() {
  const { search } = useLocation()
  return React.useMemo(() => new URLSearchParams(search), [search])
}

/**
 * 用于标签页相关操作的自定义hook，目前有关闭标签页的函数
 * @returns
 */
export function useCloseTab() {
  const dispatchRedux = useDispatch()
  const { tabsData } = useTypedSelector(
    (state: { authtoken: any }) => state.authtoken,
  )
  const { pathname } = useLocation()

  const onCurrentPageClose = (callback?: () => void, needJump = true) => {
    let newurl = ''
    if (tabsData.length === 0) {
      // 最后一个tabs
      newurl = '/srm/home'
    }
    let delkey = ''
    if (tabsData.length > 0) {
      let param = 0
      tabsData.map((item: any, index: number) => {
        if (item.url === pathname) {
          delkey = item.key
          param = index - 1
        }
        return item
      })
      // 排除下标为1的
      const url = param >= 0 ? tabsData[param].url : '/srm/home'
      newurl = url + (tabsData[param]?.search || '')
    }

    // 删除标签 跳转前一个标签页
    // deleteRouteCache(delkey)
    dispatchRedux(delTabsAction(delkey))
    callback?.()
    if (needJump) {
      history.replace(newurl)
    }
  }
  return { onCurrentPageClose }
}

/** *
 * 组件初始化的时候不执行,只有后续更新才执行的useEffect
 */
export function useSkipInitEffect(
  fn: () => void,
  dependenceList: React.DependencyList | undefined,
  // callback?: () => void
) {
  const didInit = useRef(false)
  useEffect(() => {
    if (didInit.current) {
      const callback = fn()
      return callback
    } else {
      didInit.current = true
    }
    // return callback
    // eslint-disable-next-line
  }, dependenceList)
}

/**
 * 处理页面的全局缓存
 * @returns
 */
export function usePageCache() {
  const dispatchRedux = useDispatch()
  const { pagekey } = useTypedSelector((state) => state.pageCache)
  const { tabsData } = useTypedSelector((state) => state.authtoken)
  const { pathname } = useLocation()
  const history = useHistory()
  /**
   * 设置当前pathname的缓存
   * @param state
   */
  const setCurrentPageCache = (state: any) => {
    dispatchRedux(
      setModuleDataAction({
        key: pathname,
        data: {
          pageState: state,
        },
      }),
    )
  }
  /**
   * 获取当前pathname的缓存
   * @returns
   */
  const getCurrentPageCache = () => {
    const data = pagekey.filter((item) => item.key === pathname)
    if (data.length === 1) {
      return data[0].data?.pageState
    }
    return null
  }
  /**
   * 删除当前pathname的缓存
   */
  const delCurrentPageCache = () => {
    dispatchRedux(delModuleDataAction(pathname))
  }
  /**
   * 使用特定的key值设置缓存
   * @param state
   * @param key
   */
  const setCacheWithKey = (state: any, keyName: string) => {
    dispatchRedux(
      setModuleDataAction({
        key: keyName,
        data: {
          pageState: state,
        },
      }),
    )
  }
  /**
   * 获取特定key的缓存
   * @param keyName
   * @returns
   */
  const getCacheWithKey = (keyName: string) => {
    const data = pagekey.filter((item) => item.key === keyName)
    if (data.length === 1) {
      return data[0].data?.pageState
    }
    return null
  }

  /**
   * 删除特定key的缓存
   * @param keyName
   */
  const delCacheWithKey = (keyName: string) => {
    dispatchRedux(delModuleDataAction(keyName))
  }
  const closeCurrentTab = () => {
    let newurl = ''
    if (tabsData.length === 0) {
      // 最后一个tabs
      newurl = '/srm/home'
    }
    let delkey = ''
    if (tabsData.length > 0) {
      let param = 0
      tabsData.map((item, index) => {
        if (item.url === pathname) {
          delkey = item.key
          param = index - 1
        }
        return item
      })
      // 排除下标为1的
      const url =
        param >= 0
          ? `${tabsData[param].url}${tabsData[param].search ?? ''}`
          : '/srm/home'
      newurl = url
    }
    dispatchRedux(delTabsAction(delkey))
    history.replace(newurl)
  }
  return {
    setCurrentPageCache,
    getCurrentPageCache,
    delCurrentPageCache,
    setCacheWithKey,
    getCacheWithKey,
    delCacheWithKey,
    closeCurrentTab,
  }
}
import React, { useEffect, useRef } from 'react'
import { useDispatch } from 'react-redux'
import { useHistory, useLocation } from 'react-router-dom'
import { history, useTypedSelector } from '../redux/store'
import { delTabsAction } from '../modules/authtoken'
import { delModuleDataAction, setModuleDataAction } from '../modules/pagecache'

/**
 * 获取url参数用的hook
 * @returns
 */
export function useQuery() {
  const { search } = useLocation()
  return React.useMemo(() => new URLSearchParams(search), [search])
}

/**
 * 用于标签页相关操作的自定义hook，目前有关闭标签页的函数
 * @returns
 */
export function useCloseTab() {
  const dispatchRedux = useDispatch()
  const { tabsData } = useTypedSelector(
    (state: { authtoken: any }) => state.authtoken,
  )
  const { pathname } = useLocation()

  const onCurrentPageClose = (callback?: () => void, needJump = true) => {
    let newurl = ''
    if (tabsData.length === 0) {
      // 最后一个tabs
      newurl = '/srm/home'
    }
    let delkey = ''
    if (tabsData.length > 0) {
      let param = 0
      tabsData.map((item: any, index: number) => {
        if (item.url === pathname) {
          delkey = item.key
          param = index - 1
        }
        return item
      })
      // 排除下标为1的
      const url = param >= 0 ? tabsData[param].url : '/srm/home'
      newurl = url + (tabsData[param]?.search || '')
    }

    // 删除标签 跳转前一个标签页
    // deleteRouteCache(delkey)
    dispatchRedux(delTabsAction(delkey))
    callback?.()
    if (needJump) {
      history.replace(newurl)
    }
  }
  return { onCurrentPageClose }
}

/** *
 * 组件初始化的时候不执行,只有后续更新才执行的useEffect
 */
export function useSkipInitEffect(
  fn: () => void,
  dependenceList: React.DependencyList | undefined,
  // callback?: () => void
) {
  const didInit = useRef(false)
  useEffect(() => {
    if (didInit.current) {
      const callback = fn()
      return callback
    } else {
      didInit.current = true
    }
    // return callback
    // eslint-disable-next-line
  }, dependenceList)
}

/**
 * 处理页面的全局缓存
 * @returns
 */
export function usePageCache() {
  const dispatchRedux = useDispatch()
  const { pagekey } = useTypedSelector((state) => state.pageCache)
  const { tabsData } = useTypedSelector((state) => state.authtoken)
  const { pathname } = useLocation()
  const history = useHistory()
  /**
   * 设置当前pathname的缓存
   * @param state
   */
  const setCurrentPageCache = (state: any) => {
    dispatchRedux(
      setModuleDataAction({
        key: pathname,
        data: {
          pageState: state,
        },
      }),
    )
  }
  /**
   * 获取当前pathname的缓存
   * @returns
   */
  const getCurrentPageCache = () => {
    const data = pagekey.filter((item) => item.key === pathname)
    if (data.length === 1) {
      return data[0].data?.pageState
    }
    return null
  }
  /**
   * 删除当前pathname的缓存
   */
  const delCurrentPageCache = () => {
    dispatchRedux(delModuleDataAction(pathname))
  }
  /**
   * 使用特定的key值设置缓存
   * @param state
   * @param key
   */
  const setCacheWithKey = (state: any, keyName: string) => {
    dispatchRedux(
      setModuleDataAction({
        key: keyName,
        data: {
          pageState: state,
        },
      }),
    )
  }
  /**
   * 获取特定key的缓存
   * @param keyName
   * @returns
   */
  const getCacheWithKey = (keyName: string) => {
    const data = pagekey.filter((item) => item.key === keyName)
    if (data.length === 1) {
      return data[0].data?.pageState
    }
    return null
  }

  /**
   * 删除特定key的缓存
   * @param keyName
   */
  const delCacheWithKey = (keyName: string) => {
    dispatchRedux(delModuleDataAction(keyName))
  }
  const closeCurrentTab = () => {
    let newurl = ''
    if (tabsData.length === 0) {
      // 最后一个tabs
      newurl = '/srm/home'
    }
    let delkey = ''
    if (tabsData.length > 0) {
      let param = 0
      tabsData.map((item, index) => {
        if (item.url === pathname) {
          delkey = item.key
          param = index - 1
        }
        return item
      })
      // 排除下标为1的
      const url =
        param >= 0
          ? `${tabsData[param].url}${tabsData[param].search ?? ''}`
          : '/srm/home'
      newurl = url
    }
    dispatchRedux(delTabsAction(delkey))
    history.replace(newurl)
  }
  return {
    setCurrentPageCache,
    getCurrentPageCache,
    delCurrentPageCache,
    setCacheWithKey,
    getCacheWithKey,
    delCacheWithKey,
    closeCurrentTab,
  }
}
